import React from "react";
import styled from "styled-components";
import { Player } from "video-react";
import "video-react/dist/video-react.css";

import type { DownloadAsset } from "../../types/common";
import { MarketingNarrativeFileFormats } from "../../types/marketingNarrativeFileFormats";

const StyledMedia = styled.div`
    width: 100%;
    height: auto;
`;

const Image: React.FC<{ downloadUrl: string | undefined }> = ({
    downloadUrl,
}) => (
    <StyledMedia
        as="img"
        src={downloadUrl}
        alt="Image preview"
        data-testid="media-viewer-image"
    />
);

const Video: React.FC<{ downloadUrl: string | undefined }> = ({
    downloadUrl,
}) => (
    <div data-testid="media-viewer-video">
        <StyledMedia
            as={Player}
            autoPlay
            playsInline
            src={downloadUrl}
            fluid={true}
        />
    </div>
);

export const MediaViewer: React.FunctionComponent<{
    fileFormat: string;
    previewAsset: DownloadAsset;
}> = ({ fileFormat, previewAsset }) => {
    return (
        <div data-testid="media-container">
            {(() => {
                switch (fileFormat as MarketingNarrativeFileFormats) {
                    case MarketingNarrativeFileFormats.PNG:
                    case MarketingNarrativeFileFormats.JPG:
                        return (
                            <Image downloadUrl={previewAsset?.downloadUrl} />
                        );
                    case MarketingNarrativeFileFormats.MP4:
                        return (
                            <Video downloadUrl={previewAsset?.downloadUrl} />
                        );
                    default:
                        return null;
                }
            })()}
        </div>
    );
};
